/*=============================================== Header ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import Variables from "./Variables";
import Mixins from "./Mixins";
import Image from "./Image";
import Burger from "./Burger";
/*==================== Styles ====================*/
var BurgerHeader = styled(Burger)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Logo = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: ", ";\n"], ["\n    font-weight: ", ";\n"])), Variables.FontWeights.Black);
var Container = styled.header(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    ", ";\n    z-index: 999;\n    padding: ", " 5%;\n    background-color: ", ";\n\n    a {\n        color: ", ";\n        text-decoration: none;\n\n        @media ", " {\n            &:hover {\n                color: ", ";\n            }\n\n            &:active {\n                color: ", ";\n            }\n        }\n\n        &:not(", ") {\n            font-weight: ", ";\n        }\n\n        &.active {\n            font-weight: ", ";\n        }\n    }\n\n    ", " {\n        display: none;\n\n        @media ", " {\n            display: inherit;\n        }\n    }\n\n    ", "\n"], ["\n    position: ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    ", ";\n    z-index: 999;\n    padding: ", " 5%;\n    background-color: ", ";\n\n    a {\n        color: ", ";\n        text-decoration: none;\n\n        @media ", " {\n            &:hover {\n                color: ", ";\n            }\n\n            &:active {\n                color: ", ";\n            }\n        }\n\n        &:not(", ") {\n            font-weight: ", ";\n        }\n\n        &.active {\n            font-weight: ", ";\n        }\n    }\n\n    ", " {\n        display: none;\n\n        @media ", " {\n            display: inherit;\n        }\n    }\n\n    ", "\n"])), function (_a) {
    var $position = _a.$position;
    return $position === "absolute" ? "absolute" : $position === "fixed" ? "fixed" : "relative";
}, Mixins.Flexbox({
    $align: "center",
    $justify: "space-between",
}), Variables.Spacers.M, function (_a) {
    var $headerStyle = _a.$headerStyle, $color = _a.$color;
    return $headerStyle === "plain" && $color === "primary"
        ? Variables.Colors.Primary500
        : $headerStyle === "plain" && $color === "white"
            ? Variables.Colors.White
            : "transparent";
}, function (_a) {
    var $color = _a.$color, $headerStyle = _a.$headerStyle;
    return ($headerStyle === "plain" && $color === "white") || ($headerStyle === "transparent" && $color === "primary")
        ? Variables.Colors.Primary500
        : Variables.Colors.White;
}, Variables.Breakpoints.Hover, function (_a) {
    var $color = _a.$color, $headerStyle = _a.$headerStyle;
    return ($headerStyle === "plain" && $color === "white") ||
        ($headerStyle === "transparent" && $color === "primary")
        ? Variables.Colors.Primary300
        : Variables.Colors.Gray300;
}, function (_a) {
    var $color = _a.$color, $headerStyle = _a.$headerStyle;
    return ($headerStyle === "plain" && $color === "white") ||
        ($headerStyle === "transparent" && $color === "primary")
        ? Variables.Colors.Primary600
        : Variables.Colors.Gray100;
}, Logo, Variables.FontWeights.Regular, Variables.FontWeights.Black, BurgerHeader, Variables.Breakpoints.Mobile, function (_a) {
    var $headerStyle = _a.$headerStyle, $color = _a.$color, $isOpen = _a.$isOpen;
    return $headerStyle === "transparent" && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            @media ", " {\n                transition: ", ";\n                background-color: ", ";\n            }\n        "], ["\n            @media ", " {\n                transition: ", ";\n                background-color: ", ";\n            }\n        "])), Variables.Breakpoints.Mobile, Variables.Transitions.Short, $isOpen && $color === "primary"
        ? Variables.Colors.White
        : $isOpen && $color === "white" && Variables.Colors.Primary500);
});
var LogoImg = styled(Image)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100px;\n    height: 32px;\n    object-fit: contain;\n    object-position: left center;\n"], ["\n    width: 100px;\n    height: 32px;\n    object-fit: contain;\n    object-position: left center;\n"])));
var Nav = styled.nav(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n\n    @media ", " {\n        position: absolute;\n        left: 0;\n        top: ", "px;\n        transition: ", ";\n        flex-direction: column;\n        padding: ", " 5%;\n        background-color: ", ";\n        width: 100%;\n        align-items: flex-start;\n    }\n"], ["\n    ", ";\n\n    @media ", " {\n        position: absolute;\n        left: 0;\n        top: ", "px;\n        transition: ", ";\n        flex-direction: column;\n        padding: ", " 5%;\n        background-color: ", ";\n        width: 100%;\n        align-items: flex-start;\n    }\n"
    /*==================== Component ====================*/
])), Mixins.Flexbox({
    $align: "center",
    $justify: "flex-start",
    $gap: "m",
}), Variables.Breakpoints.Mobile, function (_a) {
    var $isOpen = _a.$isOpen, $logoText = _a.$logoText;
    return ($isOpen && $logoText ? 56 : $isOpen && !$logoText ? 64 : -300);
}, Variables.Transitions.Short, Variables.Spacers.M, function (_a) {
    var $color = _a.$color, $headerStyle = _a.$headerStyle;
    return ($headerStyle === "plain" && $color === "white") || ($headerStyle === "transparent" && $color === "primary")
        ? Variables.Colors.White
        : Variables.Colors.Primary500;
});
/*==================== Component ====================*/
var Header = function (_a) {
    var _b = _a.headerStyle, headerStyle = _b === void 0 ? "plain" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.position, position = _d === void 0 ? "relative" : _d, _e = _a.logoText, logoText = _e === void 0 ? undefined : _e, logoImg = _a.logoImg, _f = _a.logoAlt, logoAlt = _f === void 0 ? "Logo" : _f, _g = _a.logoTo, logoTo = _g === void 0 ? "/" : _g, children = _a.children, props = __rest(_a, ["headerStyle", "color", "position", "logoText", "logoImg", "logoAlt", "logoTo", "children"]);
    var _h = useState(false), isOpen = _h[0], setIsOpen = _h[1];
    return (React.createElement(Container, __assign({ "$headerStyle": headerStyle, "$color": color, "$position": position, "$isOpen": isOpen }, props),
        React.createElement(Logo, { to: logoTo }, logoImg ? React.createElement(LogoImg, { src: logoImg, alt: logoAlt, width: 100, height: 32, fit: "contain" }) : logoText),
        React.createElement(BurgerHeader, { onClick: function () { return setIsOpen(!isOpen); }, isOpen: isOpen, color: (headerStyle === "plain" && color === "white") ||
                (headerStyle === "transparent" && color === "primary")
                ? "primary"
                : "white" }),
        React.createElement(Nav, { "$isOpen": isOpen, "$color": color, "$headerStyle": headerStyle, "$logoText": logoText !== undefined ? true : false }, children)));
};
export default Header;
/*==================== Types ====================*/
var headerStyles = {
    plain: "plain",
    transparent: "transparent",
};
var headerColors = {
    primary: "primary",
    white: "white",
};
var positions = {
    relative: "relative",
    absolute: "absolute",
    fixed: "fixed",
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
